import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useMemo } from 'react';
import Products from './components/Products';
import ErrorScreen from './components/ErrorScreen';
import SuccessScreen from './components/SuccessScreen';

function App() {
  let cashboxid = 'fa32183d-b846-4a68-95ad-36e35f4a44b3';
  let accesstoken = 'BLee4AVCt73zfAovG6MtnSNIt8bPgHksqSpr6WIqbVaPQoxXBNq8+vyZmWHJydcVjy/pCOKZZFkCD1sSq+0QynE=';

  // Parse URL params for testing
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const screen = params.get('screen');
  const journeyId = params.get('journeyId');
  const qrCode = params.get('qrCode');
  const errorMessage = params.get('error') || 'Test error message';

  // useEffect(() => {
  //   try {
  //     if (params.get('token')) {
  //       const cashboxScope = params.get('token');
  //       if (cashboxScope) {
  //         try {
  //           const decodedString = atob(cashboxScope);
  //           const json = JSON.parse(decodedString);
  //           if (json.cashboxid && json.accesstoken) {
  //             setCashBoxId(json.cashboxid);
  //             setAccessToken(json.accesstoken);
  //           }
  //         } catch (error) {
  //           console.error('Failed to parse cashbox_scope:', error);
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }, [params, setAccessToken, setCashBoxId]); 

  // Render specific screens based on URL params
  if (screen === 'error') {
    return (
      <ErrorScreen 
        error={errorMessage}
        onRetry={() => window.location.href = '/'}
        onCancel={() => window.location.href = '/'}
      />
    );
  }

  if (screen === 'success' && journeyId && qrCode) {
    return (
      <SuccessScreen
        journeyId={journeyId}
        qrCode={qrCode}
        cashboxid={cashboxid}
        accesstoken={accesstoken}
        productType="evcharging"
        done={() => window.location.href = '/'}
      />
    );
  }

  return (
    <div>
      <Products
        cashboxid={cashboxid}
        accesstoken={accesstoken}
      />
    </div>
  );
}

export default App;
